export default __webpack_public_path__ + "static/media/emerging-factor-tree.35e8117d.svg";